import React from 'react';
import { Music } from 'lucide-react';

const EmptyState = () => {
  return (
    <div className="text-center py-20">
      <div className="inline-flex items-center justify-center w-20 h-20 bg-violet-100 rounded-full mb-4 border border-violet-200">
        <Music className="w-10 h-10 text-violet-500" />
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2">Aucun événement</h3>
      <p className="text-gray-500 mb-6">Créez votre premier événement pour commencer 🎵</p>
    </div>
  );
};

export default EmptyState;
